import { Component, Fragment } from 'react';
import { CDN_CLRSAVE_URL } from '../../constants';
import styles from '../../styles/search.scss';
import cx from 'classnames';

interface Props {
  filters: FilterItem[];
  filterName: string;
  onCheckboxClick: any;
  category: string;
  activeFilters?: string[];
  filterCategoryValueMap: any;
  showSubFilter: boolean; // set true if want to show subcategories
}

interface FilterItem {
  label: string;
  key: string;
  subCategory?: any[];
  isSelected: boolean;
}

interface State {
  collapseFilter: boolean;
  filterCategoryValueMap: any;
  category: string;
}

class FilterGroup extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const { filterCategoryValueMap, category } = this.props;
    this.state = {
      collapseFilter: false,
      filterCategoryValueMap,
      category,
    };
  }

  public handlecollapseFilter = () => {
    const { collapseFilter } = this.state;
    this.setState({
      collapseFilter: !collapseFilter,
    });
  };

  private getAllSubCategories(filter: FilterItem): any {
    const allSubs = filter.hasOwnProperty('categoryFilter.categoryFilterValue')
      ? filter['categoryFilter.categoryFilterValue']
      : null;
    return allSubs;
  }
  // Get all subcategories for filter
  private showSubCategories(filter: FilterItem) {
    const allSubs = this.getAllSubCategories(filter);
    const { category, filterCategoryValueMap, onCheckboxClick } = this.props;
    if (
      filterCategoryValueMap[category].indexOf(filter.key) !== -1 &&
      allSubs != null &&
      allSubs.length !== 0
    ) {
      return (
        <ul className={cx(styles['filter-item-parent-subCategory'])}>
          {allSubs.map(sc => (
            <li
              className={cx(styles['filter-item'])}
              data-attr={sc.key}
              data-category="categoryFilter.categoryFilterValue"
              onClick={onCheckboxClick}
              key={sc.key}
            >
              <span
                className={cx(styles['filter-item-checkbox'], {
                  [styles['filter-item-checkbox-selected']]:
                    filterCategoryValueMap[
                      'categoryFilter.categoryFilterValue'
                    ].indexOf(sc.key) !== -1,
                })}
              >
                <img
                  src={`${CDN_CLRSAVE_URL}/ct-frontend/images/checkboxTick.png`}
                />
              </span>
              <span className={styles['filter-item-label']}>{sc.label}</span>
            </li>
          ))}
        </ul>
      );
    }
  }
  public render() {
    const {
      filters,
      onCheckboxClick,
      category,
      filterName,
      filterCategoryValueMap,
      showSubFilter,
    } = this.props;

    const { collapseFilter } = this.state;
    return (
      <div className={styles['filter-item-container']}>
        <div
          className={styles['filter-header']}
          onClick={this.handlecollapseFilter}
        >
          <span className={styles['filter-name']}>{filterName}</span>

          <span
            className={cx(styles['arrow-triangle'], {
              [styles['rotate']]: collapseFilter,
            })}
          />
        </div>
        {!collapseFilter ? (
          <ul className={cx(styles['filter-item-parent'])}>
            {filters.map((filter: FilterItem) => (
              <li
                className={cx(styles['filter-item'])}
                data-attr={filter.key}
                data-category={category}
                onClick={onCheckboxClick}
                key={filter.key}
              >
                {
                  <Fragment>
                    <span
                      className={cx(styles['filter-item-checkbox'], {
                        [styles['filter-item-checkbox-selected']]:
                          filterCategoryValueMap[category] &&
                          filterCategoryValueMap[category].indexOf(
                            filter.key
                          ) !== -1,
                      })}
                    >
                      <img
                        src={`${CDN_CLRSAVE_URL}/ct-frontend/images/checkboxTick.png`}
                      />
                    </span>
                    <span className={styles['filter-item-label']}>
                      {filter.label}
                    </span>
                    {/* Shows subcategories for the selected category filter */}
                    {showSubFilter && category === 'fundType'
                      ? this.showSubCategories(filter)
                      : null}
                  </Fragment>
                }
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    );
  }
}

export default FilterGroup;



// WEBPACK FOOTER //
// ./components/search/filterGroup.tsx